export type SpaRebuildAction = 'destroy' | 'resetGuard' | 'noop';

export type SpaRebuildInput = {
  /** Whether the SPA destroy-then-rebuild flag (+ page-type scope) is active. */
  spaRebuildEnabled: boolean;
  /** Current placement status. */
  status: string;
  /** Whether the slot has already been destroyed in the current cycle. */
  hasRebuilt: boolean;
  /** Whether there is currently a defined slot to destroy. */
  slotExists: boolean;
};

export function getSpaRebuildAction({
  spaRebuildEnabled,
  status,
  hasRebuilt,
  slotExists
}: SpaRebuildInput): SpaRebuildAction {
  if (!spaRebuildEnabled) return 'noop';

  const isRequestTrigger =
    status === 'refresh' || status === 'forceBatchRequest';

  if (!isRequestTrigger) return 'resetGuard';

  if (hasRebuilt || !slotExists) return 'noop';

  return 'destroy';
}
